const ArrowDownGreen = ({ height = 16, stroke = "#118052" }) => (
  <svg
    width="15"
    height={height}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1807 6.23633L8.34648 10.0705C7.89367 10.5233 7.15271 10.5233 6.6999 10.0705L2.86572 6.23633"
      stroke={stroke}
      strokeWidth="1.41135"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDownGreen;
